define('wizard_module.tpl', ['Handlebars','Handlebars.CompilerNameLookup'], function(Handlebars, _nl_){
	return _wrap_fn_('wizard_module', {"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    return "<h2>Module Name</h2>  ";
},"useData":true}, 'extensions/RSM/WestAcademic_Theme/1.0.0/', 'extensions/RSM/WestAcademic_Theme/1.0.0/', Handlebars);
});